export interface ISubmitWorkflow {
  name: string;
  productName?: string;
  data: {
    content?: {
      base64data?: any;
      name?: string;
      contentId?: string;
    };
    parameters?: any;
    priority?: string;
    s3content?: {
      bucket: string;
      accessKey: string;
      privateKey: string;
      files: string[];
    };
  };
}

export interface IPreSubmitWorkflow {
  name: string;
  productName?: string;
  content?: File[];
  parameters?: any;
  priority?: string;
  s3content?: {
    bucket: string;
    accessKey: string;
    privateKey: string;
    files: string[];
  };
}

/**
 * Form field name for file content uploads to ensure consistency across components
 */
export const CONTENT_FIELD_NAME = 'content';
